import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { APPLICATION_SELECTORS } from './core/store/selectors/application.selector';
import { TOAST_Z_INDEX } from './core/configurations/layout.config';

@Component({
  selector: 'lh-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  isApplicationLoading$: Observable<boolean> = this.store.select(APPLICATION_SELECTORS.selectLoading);
  readonly TOAST_Z_INDEX = TOAST_Z_INDEX;

  constructor(private readonly store: Store) {}
}
